__turbopack_context__.v({
  "active": "CircularGallery-module-scss-module__eWDh0W__active",
  "cardContent": "CircularGallery-module-scss-module__eWDh0W__cardContent",
  "cardImage": "CircularGallery-module-scss-module__eWDh0W__cardImage",
  "cardLabel": "CircularGallery-module-scss-module__eWDh0W__cardLabel",
  "cards": "CircularGallery-module-scss-module__eWDh0W__cards",
  "controls": "CircularGallery-module-scss-module__eWDh0W__controls",
  "description": "CircularGallery-module-scss-module__eWDh0W__description",
  "isDragging": "CircularGallery-module-scss-module__eWDh0W__isDragging",
  "name": "CircularGallery-module-scss-module__eWDh0W__name",
  "navButton": "CircularGallery-module-scss-module__eWDh0W__navButton",
  "navIcon": "CircularGallery-module-scss-module__eWDh0W__navIcon",
  "nextIcon": "CircularGallery-module-scss-module__eWDh0W__nextIcon",
  "position": "CircularGallery-module-scss-module__eWDh0W__position",
  "prevIcon": "CircularGallery-module-scss-module__eWDh0W__prevIcon",
  "wrapper": "CircularGallery-module-scss-module__eWDh0W__wrapper",
});
